module.exports = __webpack_public_path__ + "img/index5.42789784.png";